var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.65662 10.3104V16.6904C8.65662 17.997 10.0766 18.817 11.2099 18.1637L13.9766 16.5704L16.7433 14.9704C17.8766 14.317 17.8766 12.6837 16.7433 12.0304L13.9766 10.4304L11.2099 8.83703C10.0766 8.18369 8.65662 8.99703 8.65662 10.3104Z",
    fill: "#313131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 26C25.5 26.1381 25.6119 26.25 25.75 26.25C25.8881 26.25 26 26.1381 26 26L25.5 26ZM0.250004 26C0.250004 26.1381 0.361933 26.25 0.500004 26.25C0.638075 26.25 0.750004 26.1381 0.750004 26L0.250004 26ZM0.750006 0.999998C0.750006 0.861927 0.638077 0.749998 0.500006 0.749998C0.361935 0.749998 0.250006 0.861927 0.250006 0.999998L0.750006 0.999998ZM26 1C26 0.861929 25.8881 0.75 25.75 0.75C25.6119 0.75 25.5 0.861929 25.5 1L26 1ZM0.750004 26L0.750006 0.999998L0.250006 0.999998L0.250004 26L0.750004 26ZM25.5 1L25.5 26L26 26L26 1L25.5 1Z",
    fill: "#B2BFC1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.bb6b9eb4eb8ebc0bbcf4bc340af15158.svg";
export { ForwardRef as ReactComponent };